import {
    Box,
    Flex,
    Text,
    IconButton,
    Button,
    Stack,
    Collapse,
    Link,
    useColorModeValue,
    useBreakpointValue,
    useDisclosure,
  } from '@chakra-ui/react';


  import {
    HamburgerIcon,
    CloseIcon,
  } from '@chakra-ui/icons';
  
import { logout } from '../features/authSlice/authSlice';
import { useDispatch, useSelector } from 'react-redux';

import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';

  export default function Header() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const auth = useSelector(state => state.auth.isLoggedIn)

    const handleLogout = (e)  => {
      e.preventDefault()
      dispatch(logout())
      localStorage.removeItem('access')
      Swal.fire(
        'Logout Successful',
      )
      navigate('/')
    }

    const { isOpen, onToggle } = useDisclosure();
  
    return (
      <Box>
        <Flex
          bg={useColorModeValue('white', 'gray.800')}
          color={useColorModeValue('gray.600', 'white')}
          minH={'60px'}
          py={{ base: 2 }}
          px={{ base: 4 }}
          borderBottom={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.900')}
          align={'center'}>
          <Flex
            flex={{ base: 1, md: 'auto' }}
            ml={{ base: -2 }}
            display={{ base: 'flex', md: 'none' }}>
            <IconButton
              onClick={onToggle}
              icon={
                isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
              }
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
            />
          </Flex>
          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
            <Link href={"/"}>
                <Text
                textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
                fontFamily={'heading'}
                color={useColorModeValue('gray.800', 'white')}>
                    IExpense
                </Text>
            </Link>
  
            <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
              <DesktopNav />
            </Flex>
          </Flex>
  
          
          <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'row'}
            spacing={6}>
              {!auth ? 
              
            (
              <>
            <Button
            display={{base: 'none', md: 'inline-flex'}}
              as={'a'}
              fontSize={'sm'}
              fontWeight={400}
              variant={'link'}
              href={'/login'}>
              Sign In
            </Button>
            <Button
              display={{ base: 'none', md: 'inline-flex' }}
              as={'a'}
              fontSize={'sm'}
              fontWeight={600}
              color={'white'}
              bg={'pink.400'}
              href={'/signup'}
              _hover={{
                bg: 'pink.300',
              }}>
              Sign Up
            </Button>
            </>
            )
            :
            (
              <>
              <Button
              display={{ base: 'none', md: 'inline-flex' }}
              as={'a'}
              fontSize={'sm'}
              fontWeight={400}
              variant={'link'}
              href={'/dashboard'}>
              Dashboard
            </Button>
            <Button
              display={{ base: 'none', md: 'inline-flex' }}
              as={'a'}
              fontSize={'sm'}
              fontWeight={600}
              color={'white'}
              bg={'pink.400'}
              _hover={{
                bg: 'pink.300',
              }} onClick={handleLogout}>
              Logout
            </Button>
            </>
            )
            }
          </Stack>
        </Flex>
  
        <Collapse in={isOpen} animateOpacity>
          <MobileNav />
        </Collapse>
      </Box>
    );
  }
  
  const DesktopNav = () => {
    return (
      <Stack direction={'row'} spacing={4}>
      </Stack>
    );
  };
  
  
  const MobileNav = () => {
    return (
      <Stack
        bg={useColorModeValue('white', 'gray.800')}
        p={4}
        display={{ md: 'none' }}>
        {NAV_ITEMS.map((navItem) => (
          <MobileNavItem key={navItem.label} {...navItem} />
        ))}
      </Stack>
    );
  };
  
  const MobileNavItem = ({ label, children, href }) => {
    const { isOpen, onToggle } = useDisclosure();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const auth = useSelector(state => state.auth.isLoggedIn)

    const handleLogout = (e)  => {
      e.preventDefault()
      dispatch(logout())
      localStorage.removeItem('access')
      navigate('/')
    }
  
    return (
      <Stack spacing={4} onClick={children && onToggle}>
        <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'column'}
            spacing={6}>
              {!auth ? 
              
            (
              <>
            <Button
              as={'a'}
              fontSize={'sm'}
              fontWeight={400}
              variant={'link'}
              href={'/login'}>
              Sign In
            </Button>
            <Button
              display={{ base: 'inline-flex', md: 'inline-flex' }}
              as={'a'}
              fontSize={'sm'}
              fontWeight={600}
              color={'white'}
              bg={'pink.400'}
              href={'/signup'}
              _hover={{
                bg: 'pink.300',
              }}>
              Sign Up
            </Button>
            </>
            )
            :
            (
              <>
              <Button
              as={'a'}
              fontSize={'sm'}
              fontWeight={400}
              variant={'link'}
              href={'/dashboard'}>
              Dashboard
            </Button>
            <Button
              display={{ base: 'inline-flex', md: 'inline-flex' }}
              as={'a'}
              fontSize={'sm'}
              fontWeight={600}
              color={'white'}
              bg={'pink.400'}
              _hover={{
                bg: 'pink.300',
              }} onClick={handleLogout}>
              Logout
            </Button>
            </>
            )
            }
          </Stack>
  
        <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
          <Stack
            mt={2}
            pl={4}
            borderLeft={1}
            borderStyle={'solid'}
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            align={'start'}>
            {children &&
              children.map((child) => (
                <Link key={child.label} py={2} href={child.href}>
                  {child.label}
                </Link>
              ))}
          </Stack>
        </Collapse>
      </Stack>
    );
  };
  
  const NAV_ITEMS = [
    {
      label: 'Dashboard',
      href: '/dashboard',
    },
    
  ];